import { render } from "./Contadores.vue?vue&type=template&id=9536aa80"
import script from "./Contadores.vue?vue&type=script&lang=js"
export * from "./Contadores.vue?vue&type=script&lang=js"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__